import { PageMeta } from '../marketplace/shared/PageMeta';

export function PrivacyPage() {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <PageMeta title="Privacy Policy" description="Privacy Policy for the Second Chance Seed Network" path="/marketplace/privacy" />

      <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
      <p className="text-sm text-spi-slate mb-8">Last updated: February 2026</p>

      <div className="prose prose-sm max-w-none space-y-6 text-spi-charcoal">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
          <p>We collect the following types of information:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Account information: name, email address, phone number, role</li>
            <li>Organization details: name, type, address, country, tax ID, website</li>
            <li>Project information: descriptions, delivery addresses, seed requirements</li>
            <li>Uploaded media: images and documents associated with projects</li>
            <li>Transaction records: donation details, shipping information, tax documentation</li>
            <li>Usage data: access logs, browser information, and IP addresses</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. How We Use Your Information</h2>
          <p>Your information is used to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Operate and maintain the Platform</li>
            <li>Verify user identities and organizational status</li>
            <li>Facilitate seed donations and transactions</li>
            <li>Generate IRS Form 8283 documentation</li>
            <li>Communicate with you about your account and transactions</li>
            <li>Improve the Platform and develop new features</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Sharing with SPI and Bay Crew Tech, LLC</h2>
          <p>
            Your information may be shared between Seed Programs International (SPI) and Bay Crew Tech, LLC for Platform operation, user verification, and charitable coordination purposes. Both organizations are committed to protecting your personal information.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Media and Content Sharing</h2>
          <p>
            Images, documents, and other content uploaded to the Platform may be used by SPI and Bay Crew Tech, LLC for corporate communications, marketing, and promotional purposes as described in our Terms of Service. By uploading content, you consent to this use.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Data Retention</h2>
          <p>
            We retain your information for as long as your account is active or as needed to provide services. Transaction records and tax documentation are retained for a minimum of seven years for compliance purposes. You may request deletion of your account, subject to legal retention requirements.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information. This includes encryption of data in transit, secure storage of passwords, and access controls. However, no method of transmission over the Internet is 100% secure.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information (subject to legal requirements)</li>
            <li>Object to processing of your information</li>
            <li>Export your data in a portable format</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Cookies</h2>
          <p>
            The Platform uses essential cookies for authentication and session management. These cookies are necessary for the Platform to function and cannot be disabled.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">9. Contact</h2>
          <p>
            For privacy-related inquiries, please contact us at privacy@baycrewtech.com.
          </p>
        </section>
      </div>
    </div>
  );
}
